var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrnsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 17.71,
    viewBox: "0 0 162 17.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.07,0h1.44c2.06.15,3.92,1.18,5.36,2.62-.8.8-1.59,1.59-2.38,2.4-.99-.84-2.09-1.74-3.46-1.73-.96-.07-2.44.04-2.66,1.21-.16.57.05,1.25.61,1.51,2.06,1.06,4.58,1.01,6.47,2.44,2.06,1.51,2.23,4.6,1.08,6.71-.99,1.77-3.1,2.36-4.98,2.55h-1.61c-2.22-.2-4.31-1.25-5.78-2.93.8-.78,1.61-1.55,2.44-2.31,1.48,1.73,4,2.44,6.15,1.67,1.15-.43,1.41-2.28.33-2.92-1.94-1.11-4.33-1.04-6.23-2.26-2.17-1.27-2.56-4.45-1.29-6.49.97-1.55,2.79-2.25,4.52-2.48Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,.44c1.16,0,2.33,0,3.49.01.62,3.59,1.33,7.17,1.84,10.78.84-3.6,1.68-7.19,2.54-10.78.97,0,1.95,0,2.92,0,.78,3.6,1.86,7.15,2.45,10.79.74-3.58,1.28-7.2,1.94-10.79,1.14,0,2.28,0,3.41,0-1.13,5.61-2.31,11.21-3.47,16.82-1.08,0-2.17,0-3.25,0-.89-3.85-1.9-7.67-2.67-11.55-.58,3.91-1.74,7.7-2.62,11.55-1.03,0-2.06,0-3.1,0C2.32,11.66,1.21,6.04,0,.44Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.29.44c2.67,0,5.33-.01,8,0,1.71,0,3.48.68,4.53,2.08,1.92,2.62,1.02,6.96-2.19,8.1,1.01,2.23,2.15,4.41,3.16,6.65h-3.83c-.98-2.07-1.98-4.13-2.95-6.2h-3.41c0,2.07,0,4.13,0,6.2h-3.31V.44M25.6,3.66c0,1.43,0,2.87,0,4.3,1.84-.07,3.72.21,5.53-.23,1.83-.5,1.62-3.84-.36-3.96-1.71-.24-3.44-.08-5.17-.12Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.56.44c1.06,0,2.13,0,3.19,0,2.36,3.63,4.84,7.19,7.14,10.86-.26-3.61-.11-7.24-.15-10.85h3.31v16.83c-.97,0-1.95,0-2.92,0-2.47-3.72-5.06-7.35-7.4-11.16.25,3.71.09,7.43.14,11.15h-3.31V.44Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.33,0h1.45c2.06.15,3.91,1.19,5.36,2.61-.79.8-1.59,1.59-2.38,2.39-1.35-1.31-3.32-2.21-5.19-1.53-1.12.25-1.36,2.05-.31,2.55,1.97,1.01,4.34,1,6.21,2.25,2.99,1.9,2.63,7.13-.56,8.64-.96.49-2.03.67-3.09.81h-1.61c-2.23-.2-4.3-1.27-5.79-2.92.8-.78,1.61-1.55,2.43-2.31,1.51,1.7,4,2.44,6.16,1.66,1.16-.42,1.42-2.3.33-2.92-2.26-1.27-5.24-1.04-7.14-2.99-1.59-1.88-1.45-5.07.44-6.7,1.01-.93,2.37-1.31,3.7-1.52Z",
    fill: "#bbb",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.11,0h1.22c1.97.14,3.9,1.11,4.99,2.79,1.94,2.9,2.06,6.73,1.08,10.01-.81,2.63-3.15,4.76-5.97,4.92h-1.37c-2.92-.23-5.29-2.56-5.99-5.34-.78-3.12-.68-6.69,1.11-9.46,1.07-1.69,2.96-2.71,4.93-2.91M153.12,3.75c-1.76,1.01-2.04,3.25-2.11,5.08.07,1.75.28,3.83,1.82,4.95,1.43,1.1,3.69.72,4.71-.77.98-1.47,1.08-3.34.99-5.06-.12-1.34-.42-2.8-1.45-3.75-1.04-1.01-2.72-1.16-3.96-.44Z",
    fill: "#bbb",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.28.45c4.28,0,8.56,0,12.84,0,0,1.1,0,2.21,0,3.3-1.59,0-3.19,0-4.78,0,0,4.51,0,9.01,0,13.51-1.1,0-2.21,0-3.31,0,0-4.51,0-9.02,0-13.52-1.59,0-3.17,0-4.76.02,0-1.11,0-2.21,0-3.32Z",
    fill: "#bbb",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.34.44h3.3c.05,3.42-.1,6.85.07,10.27.04,1.87,1.42,3.95,3.5,3.72,2.12.03,3.25-2.17,3.27-4.03.11-3.31,0-6.63.04-9.95h3.3c0,3.1,0,6.2,0,9.29-.02,2.13-.39,4.44-1.9,6.05-1.06,1.2-2.65,1.73-4.2,1.93h-1.3c-1.6-.19-3.24-.77-4.31-2.03-1.42-1.62-1.82-3.86-1.8-5.95,0-3.1,0-6.19,0-9.29Z",
    fill: "#bbb",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.81.44c3.32.17,6.92-.58,9.98,1.07,2.63,1.37,3.57,4.55,3.52,7.33.05,2.89-1.28,5.98-3.96,7.32-2.92,1.63-6.36.97-9.55,1.1V.44M126.11,3.64v10.42c2.04,0,4.53.01,5.83-1.85,1.3-1.99,1.27-4.81.08-6.85-1.32-1.89-3.89-1.69-5.92-1.73Z",
    fill: "#bbb",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.31.45c1.1,0,2.21,0,3.31,0v16.83c-1.1,0-2.21,0-3.31,0,0-5.61,0-11.21,0-16.82Z",
    fill: "#bbb",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrnsLogo);
export default __webpack_public_path__ + "static/media/WrnsLogo.57366e495f28db607f614e91953f4472.svg";
export { ForwardRef as ReactComponent };